import { registerLocaleData } from '@angular/common';
import localeGermany from '@angular/common/locales/de';
import localeAustralia from '@angular/common/locales/en-AU';
import localeIndia from '@angular/common/locales/en-IN';
import localeNZ from '@angular/common/locales/en-NZ';
import localeJapan from '@angular/common/locales/ja';
import localeChina from '@angular/common/locales/zh';
import { Injectable } from '@angular/core';
import { ConfigConstants } from '../../config/config-constants';

@Injectable({
    providedIn: 'root',
})
export class LocaleService {
    private internalLocale: string;
    public constructor() {
        // do not need to register "en-US"
        if (navigator.language !== ConfigConstants.LOCALE_CODES.US) {
            this.registerCulture(<ConfigConstants.LOCALE_CODES>navigator.language);
        }
    }

    public set locale(value: string) {
        this.internalLocale = value;
    }

    public get locale(): string {
        return this.internalLocale || ConfigConstants.LOCALE_CODES.US;
    }

    public registerCulture(localeCode: ConfigConstants.LOCALE_CODES): void {
        this.locale = localeCode;

        switch (localeCode.toUpperCase()) {
            case ConfigConstants.LOCALE_CODES.JA:
            case ConfigConstants.LOCALE_CODES.JP: {
                registerLocaleData(localeJapan);
                break;
            }
            case ConfigConstants.LOCALE_CODES.IN: {
                registerLocaleData(localeIndia);
                break;
            }
            case ConfigConstants.LOCALE_CODES.AU: {
                registerLocaleData(localeAustralia);
                break;
            }
            case ConfigConstants.LOCALE_CODES.NZ: {
                registerLocaleData(localeNZ);
                break;
            }
            case ConfigConstants.LOCALE_CODES.CN: {
                registerLocaleData(localeChina);
                break;
            }
            case ConfigConstants.LOCALE_CODES.DE: {
                registerLocaleData(localeGermany);
                break;
            }
            default:
                // we do not support any other locale code other than defined in cases above
                // so, we set the locale back to "en-US"
                this.locale = ConfigConstants.LOCALE_CODES.US;
                break;
        }
    }

    public getCurrencyLocalCode(): string {
        if (!this.locale) {
            return ConfigConstants.CURRENCY_CODES.USD;
        }

        switch (this.locale.toUpperCase()) {
            case ConfigConstants.LOCALE_CODES.JA:
            case ConfigConstants.LOCALE_CODES.JP:
                return ConfigConstants.CURRENCY_CODES.JPY;
            case ConfigConstants.LOCALE_CODES.IN:
                return ConfigConstants.CURRENCY_CODES.INR;
            case ConfigConstants.LOCALE_CODES.AU:
                return ConfigConstants.CURRENCY_CODES.AUD;
            case ConfigConstants.LOCALE_CODES.NZ:
                return ConfigConstants.CURRENCY_CODES.NZD;
            case ConfigConstants.LOCALE_CODES.CN:
                return ConfigConstants.CURRENCY_CODES.CNY;
            case ConfigConstants.LOCALE_CODES.DE:
                return ConfigConstants.CURRENCY_CODES.EUR;
            default:
                return ConfigConstants.CURRENCY_CODES.USD;
        }
    }
}
